import { defineCatalogue } from '../../../i18n';

export const firstDataCatalogue = defineCatalogue(
  {
    heading: '{name} está de pé',
    description: 'A primeira leitura está a caminho.',
    'action.accounts': 'Adicionar conta',
    loading: 'Carregando',

    'steps.label': 'Situação da coleta',
    'step.accounts.title': 'Contas monitoradas',
    'step.accounts.count.one': '{n} conta do Instagram',
    'step.accounts.count.other': '{n} contas do Instagram',
    'step.accounts.none': 'Nenhuma conta ainda',
    'step.accounts.unavailable': 'Não foi possível ler as contas',
    'step.profile.title': 'Perfil de coleta',
    'step.profile.count.other': '{n} perfis em uso',
    'step.profile.shared': '{name}, o padrão da organização',
    'step.profile.none': 'Escolhido ao adicionar contas',
    'step.profile.own': 'Configuração própria em cada conta',
    'step.reading.title': 'Primeira leitura',
    'step.reading.subtitle': 'Aguardando dados',

    'figure.posts': 'Publicações lidas',
    'figure.reach': 'Alcance',
    'figure.comments': 'Comentários',
    'figure.credits': 'Créditos por dia',
    'figure.waiting': 'Aguardando dados',
    'figure.unavailable': 'sem leitura',

    'posts.title': 'Publicações',
    'posts.empty': 'Nada lido ainda',
    'posts.action': 'Ver o que será coletado',

    'meanwhile.title': 'Enquanto a leitura não chega',
    'meanwhile.accounts.title': 'Adicionar mais contas',
    'meanwhile.accounts.subtitle': 'adversários, imprensa e apoiadores',
    'meanwhile.profile.title': 'Rever o perfil de coleta',
    'meanwhile.profile.subtitle': 'muda o ritmo e o custo por dia',
    'meanwhile.team.title': 'Convidar a equipe',
    'meanwhile.team.subtitle': 'quem acompanha junto com você',
  },
  {
    heading: '{name} is up',
    description: 'The first reading is on its way.',
    'action.accounts': 'Add account',
    loading: 'Loading',

    'steps.label': 'Collection status',
    'step.accounts.title': 'Monitored accounts',
    'step.accounts.count.one': '{n} account on Instagram',
    'step.accounts.count.other': '{n} accounts on Instagram',
    'step.accounts.none': 'No accounts yet',
    'step.accounts.unavailable': 'The accounts could not be read',
    'step.profile.title': 'Collection profile',
    'step.profile.count.other': '{n} profiles in use',
    'step.profile.shared': "{name}, the organisation's default",
    'step.profile.none': 'Chosen when you add accounts',
    'step.profile.own': 'Each account has its own setup',
    'step.reading.title': 'First reading',
    'step.reading.subtitle': 'Waiting for data',

    'figure.posts': 'Posts read',
    'figure.reach': 'Reach',
    'figure.comments': 'Comments',
    'figure.credits': 'Credits per day',
    'figure.waiting': 'Waiting for data',
    'figure.unavailable': 'no reading',

    'posts.title': 'Posts',
    'posts.empty': 'Nothing read yet',
    'posts.action': 'See what will be collected',

    'meanwhile.title': 'While the first reading arrives',
    'meanwhile.accounts.title': 'Add more accounts',
    'meanwhile.accounts.subtitle': 'opponents, press and supporters',
    'meanwhile.profile.title': 'Review the collection profile',
    'meanwhile.profile.subtitle': 'changes the pace and the daily cost',
    'meanwhile.team.title': 'Invite the team',
    'meanwhile.team.subtitle': 'whoever follows along with you',
  },
);

export const fd = firstDataCatalogue.t;
export const fdPlural = firstDataCatalogue.plural;
